// Form settings (R-F1): description, open window, button and success texts; saved together with one button.

import { useState } from 'react';
import type { FormDef, FormSettings } from '@confdeck/core-shared';
import { useSync } from '../sync/react.tsx';
import { BlockEditor } from '../editor/BlockEditor.tsx';
import { LINE_KINDS } from '../editor/kinds.ts';
import { Button, Input, useToast, Field } from '../ui/primitives.tsx';
import { DateInput } from '../ui/DateInput.tsx';
import s from './forms.module.css';
import b from '../ui/builder.module.css';

/** The field works in local time; the form stores ISO in UTC. */
const toLocal = (iso?: string | null) => (iso ? new Date(new Date(iso).getTime() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16) : '');
const fromLocal = (v: string) => (v ? new Date(v).toISOString() : null);

export function FormSettingsPane({ form }: { form: FormDef }) {
  const client = useSync();
  const toast = useToast();
  const [v, setV] = useState<FormSettings>(form.settings);
  const set = (patch: Partial<FormSettings>) => setV({ ...v, ...patch });
  const save = async () => {
    const r = await client.run('form.save', { id: form.id, name: form.name, formType: form.formType, scopeId: form.scopeId ?? undefined, settings: { description: v.description ?? '', opensAt: v.opensAt ?? null, closesAt: v.closesAt ?? null, submitLabel: v.submitLabel ?? '', successTitle: v.successTitle ?? '', successText: v.successText ?? '' } });
    toast(r.ok ? { kind: 'info', text: 'Настройки сохранены' } : { kind: 'error', text: r.error.message });
  };
  return (
    <div className={b.settings}>
      <Field as="div" inline label="Описание над формой"><BlockEditor compact value={v.description ?? ''} label="Описание над формой" kinds={LINE_KINDS} onChange={(md) => set({ description: md })} /></Field>
      <Field as="div" inline label="Принимает ответы">
        <span className={s.pair}>
          <label>с <DateInput time value={toLocal(v.opensAt)} aria-label="Принимает ответы с" onChange={(x) => set({ opensAt: fromLocal(x) })} /></label>
          <label>до <DateInput time value={toLocal(v.closesAt)} aria-label="Принимает ответы до" onChange={(x) => set({ closesAt: fromLocal(x) })} /></label>
        </span>
      </Field>
      <p className={s.help}>Пусто — без ограничения. Вне этого окна форма показывает «Приём ответов ещё не начался» или «закончился», сервер ответы не примет.</p>
      <Field inline label="Текст кнопки"><Input value={v.submitLabel ?? ''} placeholder="Отправить" onChange={(e) => set({ submitLabel: e.target.value })} /></Field>
      <Field inline label="Заголовок после отправки"><Input value={v.successTitle ?? ''} placeholder="Спасибо, ответ отправлен" onChange={(e) => set({ successTitle: e.target.value })} /></Field>
      <Field as="div" inline label="Текст после отправки"><BlockEditor compact value={v.successText ?? ''} label="Текст после отправки" kinds={LINE_KINDS} placeholder="Мы напишем на указанный email." onChange={(md) => set({ successText: md })} /></Field>
      <p className={s.help}>Регистрация после отправки сразу ведёт на страницу заказа с оплатой — текст ей не нужен.</p>
      <div className={b.builderFoot}><span className={b.spacer} /><Button size="sm" variant="primary" onClick={() => void save()}>Сохранить настройки</Button></div>
    </div>
  );
}
